// extracted by mini-css-extract-plugin
export default {"labelRequired":"shared_labelRequired__gGaWa","fieldHelp":"shared_fieldHelp__OiFll","fieldError":"shared_fieldError__Zhe4x","section":"shared_section__9Kkh-"};